import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { keyframes } from '@emotion/react';
import { Fragment } from 'react';
import { RiAddLine } from 'react-icons/ri';

const scroll = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(calc(-100% - var(--gap))); }
`;

const Container = styled.section`
  overflow: hidden;
  position: relative;
  cursor: default;
  padding: 4rem 0rem;

  ${({ theme }) => theme.mediaQueries.sm} {
    padding: 8rem 0rem;
  }
`;

const MarqueeWrapper = styled.div`
  --gap: 0em;
  display: flex;
  gap: var(--gap);
`;

const MarqueeInner = styled.div`
  display: flex;
  gap: var(--gap);
  animation: ${scroll} 40s linear infinite;
  will-change: transform;
`;

const MarqueeContent = styled.div`
  color: ${({ theme }) => theme.colors.white};
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-around;
  min-width: 100%;
  gap: var(--gap);

  svg {
    font-size: 2.4rem;
    color: ${({ theme }) => theme.colors.gray};
  }
`;

const MarqueeItem = styled.p`
  ${({ theme }) => theme.mixins.HeadlineXLMobile};
`;

const Marquee = ({ marqueeItems, id = '' }) => {
  const trackCount = 2;
  const tracks = Array.from({ length: trackCount });

  return (
    <Container id={id}>
      <MarqueeWrapper>
        <MarqueeInner>
          {tracks.map((_, trackIndex) => (
            <MarqueeContent
              key={trackIndex}
              aria-hidden={trackIndex > 0 ? 'true' : undefined}
            >
              {marqueeItems.map((item, index) => (
                <Fragment key={`${trackIndex}-${index}`}>
                  <MarqueeItem>{item}</MarqueeItem>
                  <RiAddLine aria-hidden="true" />
                </Fragment>
              ))}
            </MarqueeContent>
          ))}
        </MarqueeInner>
      </MarqueeWrapper>
    </Container>
  );
};

Marquee.propTypes = {
  marqueeItems: PropTypes.arrayOf(PropTypes.node),
  id: PropTypes.string,
};

export default Marquee;
